export const formateAmount = (val, dec = 2) =>
  // TODO: remove in dev
  Number.parseFloat(val ? `${val}` : `${0}`).toFixed(dec);

export const nullToValue = (val) => (val ? val : 0);

export const valueToNull = (val) => (val ? val : null);

export const valueToString = (val) => (val ? String(val) : '');

export const valueToNumber = (val) => (Number(val) ? Number(val) : 0);

export const stringToNull = (val) => (val?.trim()?.length ? val : null);

export const trimObjectValues = (data) => {
  for (const key in data) {
    if (typeof data[key] === 'string') {
      data[key] = data[key]?.trim();
    }
  }
  return data;
};

export const numberPadding = (num = 0, totalLength = 2, pattern = '0') => String(num).padStart(totalLength, pattern);

export const stringToNumber = (value) => {
  return !Number.isNaN(Number.parseFloat(value)) ? Number.parseFloat(value) : 0.0;
};

export const booleanToNumber = (val) => (val ? 1 : 0);

export const removeNAfromObjectValues = (data) => {
  for (const key in data) {
    if (data[key] === 'NA') {
      data[key] = '';
    }
  }
  return data;
};

export const formFlagToBoolean = (val) => String(val).toUpperCase() === 'Y';

export const formBooleanToFlag = (val) => (val ? 'Y' : 'N');

export const convertToFloat = (val, decimal = 2) => Number.parseFloat(val > 0 ? val : 0).toFixed(decimal);

export const filterNullishFromObject = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_key, value]) => value !== undefined && value !== null));

export const convertMilesToKm = (miles = 0) => miles * 1.609344;

export const getUniqueValuesFromArray = (array) => [...new Set(array || [])];

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return `${text.slice(0, maxLength)}...`;
  }
  return text;
};
